import React, { useState } from "react";

const DemoModal = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    organization: "",
    role: "",
    useCase: "",
    priority: "normal",
    message: "",
  });

  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  if (!isOpen) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // const submissionData = {
      //   ...formData,
      //   submittedAt: new Date().toISOString(),
      // };

      // console.log("form submitted for demo!", submissionData);

      const response = await fetch("https://wkzjpvgwn2.execute-api.us-east-1.amazonaws.com/Production/demo-request", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name: formData.name.trim(),
          email: formData.email.trim(),
          reason: `
    Organization: ${formData.organization}
    Role: ${formData.role}
    Use Case: ${formData.useCase}
    Priority: ${formData.priority}

    Message:
    ${formData.message}
        `,
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to submit request");
      }

      setSubmitted(true);

      // Close modal only on success
      setTimeout(() => {
        setSubmitted(false);
        onClose();
        setFormData({
          name: "",
          email: "",
          organization: "",
          role: "",
          useCase: "",
          priority: "normal",
          message: "",
        });
      }, 2500);


      // Close modal gracefully after 2.5 seconds
    } catch (err) {
      console.error("Submission error:", err);
      alert("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="demo-modal-overlay">
      <div className="demo-modal-container">
        <button className="demo-modal-close" onClick={onClose}>
          &times;
        </button>

        {!submitted ? (
          <>
            <h2 className="demo-modal-title">Request a Consultation</h2>
            <p className="demo-modal-subtitle">
              Share a few details about the intelligence support you need. We will follow up to determine whether Weathervane Intel is the right fit for your executive protection, travel, event, or OSINT requirements.
            </p>

            <form onSubmit={handleSubmit} style={styles.form}>
              <div style={styles.row}>
                <input
                  name="name"
                  placeholder="Full Name"
                  required
                  onChange={handleChange}
                  className="demo-modal-input"
                />
                <input
                  name="email"
                  type="email"
                  placeholder="Email"
                  required
                  onChange={handleChange}
                  className="demo-modal-input"
                />
              </div>

              <div style={styles.row}>
                <input
                  name="organization"
                  placeholder="Organization"
                  onChange={handleChange}
                  className="demo-modal-input"
                />
                <input
                  name="role"
                  placeholder="Role / Title"
                  onChange={handleChange}
                  className="demo-modal-input"
                />
              </div>

              <select
                name="useCase"
                onChange={handleChange}
                className="demo-modal-input"
                required
              >
                <option value="">Primary intelligence need</option>
                <option value="executive_protection">Executive Protection Support</option>
                <option value="family_office">Family Office / UHNW Support</option>
                <option value="corporate_security">Corporate Security</option>
                <option value="travel_intelligence">Travel Intelligence</option>
                <option value="event_intelligence">Event Intelligence</option>
                <option value="online_exposure">Online Exposure Assessment</option>
                <option value="custom_osint">Custom OSINT Report</option>
                <option value="other">Other</option>
              </select>

              <select
                name="priority"
                onChange={handleChange}
                className="demo-modal-input"
              >
                <option value="normal">Timeline: Initial inquiry</option>
                <option value="soon">Timeline: Active planning</option>
                <option value="urgent">Timeline: Time-sensitive need</option>
              </select>

              <textarea
                name="message"
                placeholder="Briefly describe the client, asset, travel, event, exposure concern, or intelligence question."
                rows={3}
                onChange={handleChange}
                className="demo-modal-textarea"
              />

              <button type="submit" className="demo-modal-submit" disabled={loading}>
                {loading ? "Submitting..." : "Request Consultation"}
              </button>
            </form>
          </>
        ) : (
          <div style={styles.success}>
            <h3>Request Received</h3>
            <p>Thank you. We will review your inquiry and follow up regarding next steps.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default DemoModal;

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0,0,0,0.6)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
    padding: "20px 10px",      // keeps modal away from top/bottom edges
  },
  modal: {
    width: "90%",
    maxWidth: "520px",
    maxHeight: "90vh",          // limits vertical size
    overflowY: "auto",          // allows scrolling inside modal
    background: "#fff",
    borderRadius: "8px",
    padding: "24px",
    position: "relative",
    boxSizing: "border-box",    // ensures padding is included in width/height
  },
  closeBtn: {
    position: "absolute",
    top: "10px",
    right: "14px",
    border: "none",
    background: "none",
    fontSize: "20px",
    cursor: "pointer",
  },
  title: {
    marginBottom: "6px",
  },
  subtitle: {
    marginBottom: "16px",
    color: "#555",
    fontSize: "14px",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  row: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  input: {
    flex: 1,
    padding: "10px",
    borderRadius: "6px",
    border: "1px solid #ccc",
    fontSize: "14px",
  },
  textarea: {
    padding: "10px",
    borderRadius: "6px",
    border: "1px solid #ccc",
    fontSize: "14px",
  },
  button: {
    marginTop: "10px",
    padding: "12px",
    border: "none",
    backgroundColor: "#1f2937",
    color: "#fff",
    borderRadius: "6px",
    cursor: "pointer",
    fontWeight: "500",
  },
  success: {
    textAlign: "center",
    padding: "30px 10px",
  },
};